export default __webpack_public_path__ + "static/media/infographic-quiz-false.c0a371e6.svg";